import { UserInterface } from '@e3labs/isa-data-dictionary';
import { AxiosResponse } from 'axios';
import api from '~/services/api';

class ClientReportChecklistService {
  getListAllReportsChecklist({ skip = 0, limit = 10, ...rest }, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/questionary/report/', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getListCountReportsChecklist({ skip = 0, limit = 10, ...rest }, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/questionary/report?isCount=true', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getSellers({
    queryString,
    userExternalCodes
  }: {
    queryString?: string;
    userExternalCodes?: string;
  }): Promise<AxiosResponse<UserInterface[] | null>> {
    return api.get('/user', {
      params: {
        queryString,
        userExternalCodes
      }
    });
  }

  getAnswers({ skip = 0, limit = 10, questionaryId, ...rest }): Promise<AxiosResponse<any[] | null>> {
    return api.get(`/questionary/report/response/${questionaryId}`, {
      params: {
        skip,
        limit,
        ...rest
      }
    });
  }

  getClients({
    skip = 0,
    limit = 20,
    userExternalCode,
    queryString
  }: {
    skip?: number;
    limit?: number;
    userExternalCode: string;
    queryString: string;
  }): Promise<AxiosResponse<any[] | null>> {
    return api.get('/client', {
      params: {
        skip,
        limit,
        fieldsToShow: 'externalCode,name',
        userExternalCode,
        queryString
      }
    });
  }

  getCSV({ ...params }: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/questionary/report/export', {
      params: {
        ...params
      }
    });
  }

  getXls({ ...params }): Promise<AxiosResponse<any[] | null>> {
    return api.get('/questionary/report/export', {
      params: {
        ...params
      },
      headers: {
        'Content-Disposition': 'attachment; filename=report.xlsx',
        'Content-Type': 'application/vnd.ms-excel'
      },
      responseType: 'arraybuffer'
    });
  }
}

export default new ClientReportChecklistService();
